import { API_QINIU_DOMAIN } from '@constants';
import { QiniuTokenType } from '@types';
import axiosOrig, { type AxiosRequestConfig } from 'axios';
import { objectToFormData, toPercent } from 'pano-utils';
import axios from './axios';

interface Token {
  token: null | string;
  timestamp: number;
}

const tokens: Record<QiniuTokenType, Token> = {
  [QiniuTokenType.media]: {
    token: null,
    timestamp: 0,
  },
  [QiniuTokenType.thumb]: {
    token: null,
    timestamp: 0,
  },
};

const getToken = async (tokenType: QiniuTokenType): Promise<string> => {
  const { timestamp, token } = tokens[tokenType];
  if (!token || Date.now() - timestamp > 240000) {
    const url = {
      [QiniuTokenType.media]: '/uptoken/media',
      [QiniuTokenType.thumb]: '/uptoken/thumb',
    }[tokenType];
    const { token: newToken } = await axios.get<{ token: string }>(
      `${API_QINIU_DOMAIN}${url}`
    );
    tokens[tokenType] = {
      token: newToken,
      timestamp: Date.now(),
    };
    return newToken;
  }
  return token;
};

interface Params {
  tokenType: QiniuTokenType;
  key: string;
  file: File;
  onProgress?: (progress: string) => void;
}

interface ReqData {
  key: string;
  file: File;
  token: string;
}

const uploadToQiniu = async ({
  tokenType,
  key,
  file,
  onProgress,
}: Params): Promise<string> => {
  const token = await getToken(tokenType);
  const requestData: ReqData = { file, key, token };
  const config: AxiosRequestConfig = { withCredentials: false };
  if (onProgress) {
    // @ts-ignore
    config.onUploadProgress = (e: ProgressEvent) => {
      onProgress(toPercent(e.loaded / e.total));
    };
  }
  const resp = await axiosOrig.post(
    'https://upload.qiniup.com',
    objectToFormData(requestData),
    config
  );
  const { key: url } = resp.data as { key: string; hash: string };
  return url;
};

export default uploadToQiniu;
